import actions from './actions'
import mutations from './mutations'

const dashboard = {
    namespaced: true,
    state: {
        isLoaded: false,
        clients: {
            all: 0,
            allocated: 0,
            unallocated: 0
        },
        workedServerCount: 0,
        servers: []
    },
    mutations,
    actions
}

export default dashboard
